<form [formGroup]="form()">
  @if (creditorIdMayInvalid()) {
    <div class="notification is-warning" translate="warnings.creditorId"></div>
  }

  @if (form()) {
    <app-creditor-search
      [form]="form()"
      controlName="creditorId"
      (selected)="handleCreditorResultSelected($event)"
    ></app-creditor-search>

    <app-creditor-search
      [form]="form()"
      controlName="name"
      byName
      (selected)="handleCreditorResultSelected($event)"
    ></app-creditor-search>
  }

  @if (isMaybeOneTimeDirectDebit()) {
    <div class="notification is-warning" translate="warnings.maybeOneTimeDirectDebit"></div>
  }

  <fino-input formControlName="purpose" label="purpose" validationIndicator> </fino-input>

  <fino-input formControlName="mref" label="mref" validationIndicator> </fino-input>

  <button
    type="submit"
    fino-button
    (click)="submit()"
    [disabled]="!isFormValid"
    [primary]="true"
    class="mb-3"
  >
    @if (isUpdateMode()) {
      <span translate="directDebits.update"> </span>
    } @else {
      <span translate="directDebits.add"> </span>
    }
  </button>

  @if (hasDirectDebits()) {
    <div class="columns" [formGroup]="searchForm">
      <div class="column is-8">
        <fino-input formControlName="search" class="mr-2" label="Suchen"> </fino-input>
      </div>
      <div class="column">
        <button class="mt-1 is-fullwidth is-medium" fino-button (click)="deleteAllItems()">
          <label class="mr-1" translate="directDebits.all"></label>
          <fino-icon icon="Bin 1"></fino-icon>
        </button>
      </div>
    </div>
  }

  @if (hasDirectDebits()) {
    <div class="items-container">
      @for (directDebit of filteredDirectDebits(); track directDebit.id) {
        <article [class.is-primary]="directDebit.selected" class="panel">
          <div class="panel-heading">
            <div class="columns">
              <div class="column">
                <p class="has-text-white">{{ directDebit.name }}</p>
              </div>
              <div class="column is-flex is-justify-content-flex-end">
                <fino-icon
                  icon="Pencil 2"
                  (click)="editItem(directDebit)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Common File Double"
                  (click)="duplicateItem(directDebit)"
                  class="has-text-white mr-3"
                ></fino-icon>
                <fino-icon
                  icon="Bin 1"
                  (click)="deleteItem(directDebit, !directDebit.selected)"
                  class="has-text-white"
                ></fino-icon>
              </div>
            </div>
          </div>

          <div
            class="panel-block is-flex is-flex-direction-column is-align-items-flex-start"
            [class.has-text-grey-light]="!directDebit.selected"
          >
            <label
              ><span translate="directDebits.creditorId"></span>
              <b>{{ directDebit.creditorId }}</b>
            </label>

            <label
              ><span translate="directDebits.mref"></span> <b>{{ directDebit.mref }}</b></label
            >

            <label
              ><span translate="directDebits.purpose"></span>
              <b>{{ directDebit.purpose }}</b></label
            >
          </div>
        </article>
      }
    </div>
  }
</form>
